/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { dark } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      fontFamily: '"Inter", "Roboto", sans-serif',
      fontSize:   pxToRem(14),      // <-- tamaño global del label
      color: dark.main,
    },
  },
};

export default formLabel;
